module.exports = __webpack_public_path__ + "img/print.e784beca.svg";